import React from 'react'
import { useIntl } from 'react-intl'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import OrderUpsellTileWithTracking from 'components/Common/OrderUpsellTileWithTracking'

interface Props {
  flightUpsellData: App.FlightUpsell
  variant?: 'compact' | 'default'
  onDismiss?: () => void
}

function FlightUpsellTile(props: Props) {
  const {
    flightUpsellData,
    variant = 'default',
    onDismiss,
  } = props
  const intl = useIntl()

  const {
    flightTitle,
    flightPrice,
    flightLink,
  } = flightUpsellData

  return <OrderUpsellTileWithTracking
    title={flightTitle}
    description={intl.formatMessage({
      id: 'nuyEYXWqlQyTcRb4idML',
      defaultMessage: 'Explore and compare competitive prices from all major airlines.',
      description: 'Description for flight upsell tile on booking confirmation',
    })}
    price={flightPrice}
    priceUnit="adult"
    IconComponent={LinePlaneDepartureIcon}
    to={flightLink}
    analyticsSubject="flight"
    variant={variant}
    onDismissClick={onDismiss}
  />
}

export default FlightUpsellTile
